import React from "react";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { connect } from "react-redux";
import { Field, reduxForm, submit, startSubmit } from "redux-form";
import {
  insertNews,
  openNewsModal,
  loadNewsItem,
  updateNewsImage,
} from "ActionsNews";
import { checkContentDashboardStatus } from "GeneralTabAction";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";

import {
  BASE_IMAGES_URL,
  COMMON_FAIL_MESSAGE,
  maxLengthObjectFc,
} from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import InlineCropper from "InlineCropper";
import LocaleStrings from "Languages";

var MAXLENOBJ = {};
class AddNews extends BaseComponent {
  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.state = { loading: false, imagedata: "", active: false };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    MAXLENOBJ = maxLengthObjectFc(this.props.history); // filter This form name object With route
  }

  open() {
    this.props.loadNewsItem({});
    this.props.reset();
    this.setState({ ...this.state, loading: false });
    this.props.openNewsModal({ showModal: true });
  }

  close() {
    this.props.reset();
    this.setState({ active: false, loading: false, imagedata: "" });
    this.props.openNewsModal({ showModal: false });
  }

  submitFormOn = (e) => {
    this.props.dispatch(startSubmit("AddNewsForm"));

    this.formRef.current.saveImage(() => {
      this.props.dispatch(submit("AddNewsForm"));
    });
  };

  render() {
    var {
      handleSubmit,
      pristine,
      dirty,
      submitting,
      valid,
      submit,
      imagedata,
    } = this.props;

    var edit = false;

    if (this.props.initialValues.newsid) {
      edit = true;
    }

    var disabled = !(
      (dirty && valid) ||
      (edit && pristine && this.state.active)
    );
    if (edit && imagedata == "" && imagedata != "no_img") {
      disabled = true;
    } else if (
      !edit &&
      (imagedata == "no_img" ||
        imagedata == "" ||
        imagedata == "null" ||
        imagedata == null)
    ) {
      disabled = true;
    }
    if (
      edit &&
      imagedata != "" &&
      imagedata != "no_img" &&
      imagedata != "null" &&
      imagedata != null &&
      !dirty &&
      valid &&
      pristine
    ) {
      disabled = false;
    }

    return (
      <div>
        <Button
          className="btn-custom-blue schedule-add-button"
          onClick={this.open.bind(this)}
        >
          <img
            style={{ paddingRight: 8, paddingBottom: 3 }}
            src="../../style/images/header-icons/plus.png"
          ></img>
          {LocaleStrings.news_addNews}
        </Button>
        <div>
          <Modal
            className="modal-container"
            show={this.props.showModal === true ? true : false}
            onHide={this.close}
            animation={true}
            keyboard={false}
            backdrop="static"
            enforceFocus={false}
            size={"lg"}
          >
            <form onSubmit={handleSubmit(submit)} encType="multipart/form-data">
              <Modal.Header>
                <div className="import-modal-title">{`${
                  edit ? LocaleStrings.update : LocaleStrings.add
                } News`}</div>
                <button
                  type="button"
                  className="i-custom-cross-popup pull-right"
                  onClick={() => this.close()}
                >
                  <img
                    className="i-custom-small"
                    src="../../style/images/custom-icons/cross-black.png"
                  />
                </button>
              </Modal.Header>
              <Modal.Body>
                <BasicForm
                  {...this.props}
                  newsitem={this.props.initialValues}
                  session={this.props.session}
                  onImageChange={(img) => this.setState({ active: true })}
                  ref={this.formRef}
                />
              </Modal.Body>
              <Modal.Footer>
                <Button className="btn btn-custom-white" onClick={this.close}>
                  {LocaleStrings.news_closebutton}
                </Button>
                <Button
                  className="btn btn-custom-blue ml-10"
                  type="button"
                  loading={submitting}
                  onClick={this.submitFormOn}
                  disabled={disabled}
                >
                  {LocaleStrings.news_savebutton}
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
        </div>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};
  var maxLengthFields = ["newstitle", "newscontent"];
  var requiredFields = ["newstitle", "newscontent"];
  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = "Required";
    }
    if (field == "newstitle") {
      if (values[field] && values[field].trim() === "") {
        errors[field] = "Required";
      }
    }
  });

  /*** Max Length Validation ***/
  maxLengthFields.forEach((field) => {
    if (values[field] && MAXLENOBJ) {
      if (values[field].length > MAXLENOBJ[field]) {
        errors[field] = LocaleStrings.max_characters_left + MAXLENOBJ[field];
      }
    }
  });

  return errors;
}

function mapStateToProps(state) {
  return {
    session: state.session,
    showModal: state.newsModal,
    initialValues: state.newsitem,
    imagedata:
      state.newsImage !== null &&
      state.newsImage !== "null" &&
      state.newsImage !== "" &&
      state.newsImage !== undefined
        ? state.newsImage
        : null,
  };
}

function onFormSubmit(values, dispatch, props) {
  values.newstitle = values.newstitle.trim();
  var data = { ...values };

  //var { imagedata } = props;
  let imagedata = props.imagedata;
  if (imagedata === "" || imagedata == "no_img") {
    imagedata = null;
  }

  var newsitem = props.initialValues;

  return new Promise((resolve, reject) => {
    return props.insertNews(
      props.session,
      data,
      newsitem,
      imagedata,
      (result) => {
        props.stopSubmit("AddNewsForm");
        if (result.error === 1) {
          props.showError(COMMON_FAIL_MESSAGE);
          return reject(result.error);
        } else if (result.error === 2) {
          props.showError("There was an error uploading image!");
          return reject(result.error);
        } else {
          props.openNewsModal({ showModal: false });
          props.reset();
          props.showSuccess("News list updated successfully");
          props.checkContentDashboardStatus(props.session);
          return resolve(result);
        }
      }
    );
  });
}

export default connect(mapStateToProps, {
  insertNews,
  openNewsModal,
  loadNewsItem,
  updateNewsImage,
  showError,
  showSuccess,
  checkContentDashboardStatus,
})(
  reduxForm({
    validate,
    form: "AddNewsForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    onSubmit: onFormSubmit,
  })(AddNews)
);

class BasicForm extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      imagePreviewUrl: "",
      imageAvailableForCrop: false,
      imageSelected: true,
    };
    if (props.newsitem && props.newsitem.newsimage) {
      this.state = {
        imagePreviewUrl: `${BASE_IMAGES_URL}/${props.newsitem.newsimage}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`,
        imageAvailableForCrop: false,
        imageSelected: true,
      };
    }
    this.onImageSave = this.onImageSave.bind(this);
    this.cropperRef = React.createRef();
    this.props.updateNewsImage("no_img");
  }

  onImageSave = (img) => {
    this.setState({ imagePreviewUrl: img });
    this.props.updateNewsImage(img);
  };

  saveImage = (callback) => {
    if (this.state.imageAvailable) {
      this.cropperRef.current.saveImage(callback);
    } else {
      callback();
    }
  };

  onImageChange = (imageAvailable) => {
    if (imageAvailable !== undefined) this.setState({ imageAvailable });

    if (imageAvailable) {
      this.setState({ imageSelected: true });
    } else {
      this.setState({ imageSelected: false });
    }
  };

  render() {
    let { imagePreviewUrl } = this.state;

    var { newsitem } = this.props;

    return (
      <div className="basicform">
        <Field
          name="newstitle"
          label="News Title"
          placeholder="News title"
          type="text"
          component={this.renderFieldText}
          mandatory="true"
          labelposition={LABEL_POSITION_TOP}
          maxlength={MAXLENOBJ.newstitle ? MAXLENOBJ.newstitle : ""}
        />
        <div className="form-group">
          <div className="row">
            <label className="control-label-top col-md-12">
              News Image<span className="label-mandatory">*</span>
            </label>
            <div className="col-md-12">
              <InlineCropper
                width={700}
                height={420}
                border={10}
                onImageSave={this.onImageSave}
                onImageChange={this.onImageChange}
                imagepath={imagePreviewUrl}
                imageType="jpg"
                ref={this.cropperRef}
              />
              <div className="image-subtitle-info">
                * Recommended image size - 350 wide x 210 tall
              </div>
              {this.state.imageSelected ? (
                ""
              ) : (
                <div
                  className="text-help label-text-help"
                  style={{ color: "#d9534f" }}
                >
                  Image required
                </div>
              )}
            </div>
          </div>
        </div>
        {/* <Field
          name="newscontent"
          label="News Content"
          placeholder="Enter news content"
          mandatory="true"
          type="minimal"
          component={this.renderRichTextareaWithLabelTinymce}
          labelposition={LABEL_POSITION_TOP}
          height={400}
        /> */}
        <Field
          name="newscontent"
          label={LocaleStrings.news_label_content}
          placeholder={LocaleStrings.news_placeholder_content}
          mandatory="true"
          component={this.renderFieldTextarea}
          // maxlength={2000}
          labelposition={LABEL_POSITION_TOP}
          maxlength={MAXLENOBJ.newscontent ? MAXLENOBJ.newscontent : ""}
        />
      </div>
    );
  }
}
